import { parseJSON } from "date-fns";
import instance from "../axiosConfig";
import { Version, VersionResponse, VersionStatus } from "./models";

export class VersionManagementService {
    get = async (): Promise<Array<Version>> => {
        const response = await instance.get<Array<VersionResponse>>(`api/versions`);
        const data = response.data.map((version) => ({
            ...version,
            publicationDate: parseJSON(version.publicationDate),
        }));

        return data;
    };

    createVersion = async (version: string): Promise<Version> => {
        const response = await instance.post<Version>(
            `/api/versions/publishversion`,
            { version },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    getCreateStatus = async (): Promise<VersionStatus> => {
        const response = await instance.get<VersionStatus>(`api/versions/publishversionstatus`);
        return response.data;
    };

    deleteVersion = async (versionId: string): Promise<boolean> => {
        try {
            const response = await instance.delete<boolean>(`api/versions/${versionId}`);

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };

    renameVersion = async (versionId: string, versionSlug: string): Promise<Version | null> => {
        try {
            const response = await instance.post<VersionResponse>(
                `api/versions/${versionId}`,
                { versionSlug },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return { ...response.data, publicationDate: parseJSON(response.data.publicationDate) };
        } catch {
            return null;
        }
    };
}
